let colors = {
    black: "#000000",
    indigo: "#4351af",
    lightIndigo : "#8d98f2",
    powderBlue: "#90caf9",
    white: "#ffffff"
}

export {colors}